module.exports = __webpack_public_path__ + "fonts/4827b9a0968bfaceb2bda4ccbd906252.svg";